import CRMEditUserIBManagerForm from './CRMEditUserIBManagerForm';

export default CRMEditUserIBManagerForm;
